export const appConfig = {
  targetName: 'Brina',
  senderName: 'Naufal',
  whatsappNumber: '6281234567890',
  whatsappMessage: 'I said yes!! 💖',
};
